import PageSection from '../page-section/PageSection';
import titleStyles from '../shared/Title.module.css';
import styles from './PrizeRedemptionDescription.module.css';

interface IPrizeRedemptionDescription {
  title: string;
}

const PrizeRedemptionDescription = ({ title }: IPrizeRedemptionDescription) => {
  return (
    <PageSection>
      <div className={styles.mainContainer}>
        <p className={titleStyles.mainTitle}>{title}</p>
        <p className={styles.subtitle}>
          Exchange your tokens for your choice of <br /> our epic {title}s
        </p>
      </div>
    </PageSection>
  );
};

export default PrizeRedemptionDescription;
